import getWithToken from './base/get-with-token'

const getUserRoles = getWithToken('/user-role')

export default getUserRoles